export type MarketCode = 'US' | 'GB' | 'CA' | 'ES' | 'AU'

export type Market = {
  code: MarketCode
  /** Used in “Can I use TinyInvoice.app in …?” */
  countryName: string
}

export const MARKETS: Record<MarketCode, Market> = {
  US: { code: 'US', countryName: 'the United States' },
  GB: { code: 'GB', countryName: 'the United Kingdom' },
  CA: { code: 'CA', countryName: 'Canada' },
  ES: { code: 'ES', countryName: 'Spain' },
  AU: { code: 'AU', countryName: 'Australia' },
}

const PATH_SEGMENT_TO_MARKET: Record<string, MarketCode> = {
  us: 'US',
  uk: 'GB',
  ca: 'CA',
  es: 'ES',
  au: 'AU',
}

export function parseMarketCode(value: string | null | undefined): MarketCode | null {
  if (!value) {
    return null
  }
  const upper = value.trim().toUpperCase()
  if (upper === 'UK') {
    return 'GB'
  }
  if (upper in MARKETS) {
    return upper as MarketCode
  }
  return null
}

/** /us, /uk, /ca (first path segment) — for future locale landing routes. */
export function parseMarketFromPath(pathname: string): MarketCode | null {
  const segment = pathname.split('/').filter(Boolean)[0]?.toLowerCase()
  if (!segment) {
    return null
  }
  return PATH_SEGMENT_TO_MARKET[segment] ?? null
}

export function getMarket(countryCode: string | null | undefined): Market | null {
  const code = parseMarketCode(countryCode)
  return code ? MARKETS[code] : null
}
